<template>
    <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/>
</template>

<script>
    export default {
        name: 'filter',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Filter.vue